import { escape_html } from 'utils';
export const old_heat_device = [
    'T100',
    'T102',
    'L1',
    'H-1V',
    'H-1V eBus',
    'H-1 Navien',
    'H-1B',
    'BT-2',
    'CONNECT',
    'SMART',
];
export const heat_device = [
    'SMART+',
    'H1000+',
    'H2000+',
    'H1000',
    'H2000',
    'GTW-100',
    'CLIMATIC',
    'CLIMATIC_PRO',
    'H700_PRO',
    'H1000_PRO',
    'H1500_PRO',
    'H2000_PRO',
    'H1V',
    'SMART',
];
export const car_device = [
    'ZTC-300',
    'ZTC-800',
    'ZTC-720',
    'ZTC-710',
    'ZTC-700',
    'ZTC-200',
    'ZTC-110',
    'ZTC-100',
];
export const security_device = ['C2000+', 'SX350', 'C2000_PRO'];
export default {
    ...BRAND_DICT,
    name_html: escape_html(BRAND_DICT.name),
    short_name_html: escape_html(BRAND_DICT.short_name),
};
